import { useState } from 'react'
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { getV1MeRetrieveQueryOptions, useActivationsAdminStudentProjectsList } from '@/api/client'
import type { ActivationsAdminStudentProjectsListParams } from '@/api/model'
import { ActivationList, type ActivationListParams } from '@/components/activation/activation-list'

export const Route = createFileRoute('/_panel/zadania/projekty/')({
  beforeLoad: async ({ context }) => {
    // Operator-only area (admin + superadmin) — teachers bounced (FR-023).
    const me = await context.queryClient.ensureQueryData(getV1MeRetrieveQueryOptions())
    if (me.status === 200 && me.data.role !== 'admin' && me.data.role !== 'superadmin') {
      throw redirect({ to: '/' })
    }
  },
  component: StudentProjectListPage,
})

const PAGE_SIZE = 25

function StudentProjectListPage() {
  const navigate = useNavigate()
  const [params, setParams] = useState<ActivationListParams>({ page: 1, page_size: PAGE_SIZE })

  const listParams: ActivationsAdminStudentProjectsListParams = {
    page: params.page,
    page_size: params.page_size,
    search: params.search,
    state: params.state,
  }
  const query = useActivationsAdminStudentProjectsList(listParams)
  const data = query.data?.status === 200 ? query.data.data : undefined
  const failed = query.isError || (query.data !== undefined && query.data.status !== 200)

  return (
    <ActivationList
      activeTab="projekty"
      title="Projekty uczniowskie"
      createLabel="Nowy projekt uczniowski"
      onCreate={() => navigate({ to: '/zadania/projekty/nowe' })}
      onRowClick={(row) => navigate({ to: '/zadania/projekty/$uid', params: { uid: row.uid } })}
      rows={data?.results ?? []}
      count={data?.count ?? 0}
      isLoading={query.isLoading}
      failed={failed}
      onRetry={() => void query.refetch()}
      params={params}
      onParamsChange={setParams}
      countNoun={['projekt', 'projektów']}
      emptyMessage="Brak projektów uczniowskich spełniających kryteria."
    />
  )
}
